<div class="heritage-category">
  <div class="page-header">
    <div>
      <h2>分类管理</h2>
      <p>维护文章分类名称、编码、类型、封面、图标、排序和启用状态。</p>
    </div>
    <button type="button" class="primary-btn" :disabled="loading" @click="openCreate">
      新增分类
    </button>
  </div>

  <div v-if="errorMsg" class="error-banner">{{ errorMsg }}</div>

  <div class="toolbar">
    <input
      v-model="keyword"
      type="search"
      class="search-input"
      placeholder="搜索分类名称、编码"
      autocomplete="off"
      @input="handleSearchInput"
      @keyup.enter="handleSearch"
    />
    <select v-model="filterType" class="type-filter" :disabled="loading" @change="handleTypeFilterChange">
      <option value="">全部类型</option>
      <option
        v-for="item in CATEGORY_TYPE_OPTIONS"
        :key="item.value"
        :value="item.value"
      >
        {{ item.label }}
      </option>
    </select>
    <button type="button" class="secondary-btn" :disabled="loading" @click="handleSearch">
      查询
    </button>
    <button type="button" class="secondary-btn" :disabled="loading" @click="resetSearch">
      重置
    </button>
  </div>

  <div class="table-container">
    <div v-if="loading" class="loading-wrapper">
      <div class="loading-spinner"></div>
      <span>加载中...</span>
    </div>

    <div class="table-scroll">
      <table v-if="!loading" class="data-table">
        <thead>
          <tr>
            <th class="image-col">图标</th>
            <th class="image-col">封面</th>
            <th>ID</th>
            <th>名称</th>
            <th>编码</th>
            <th>类型</th>
            <th>描述</th>
            <th>排序</th>
            <th>状态</th>
            <th>更新时间</th>
            <th class="action-col">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="categoryList.length === 0">
            <td colspan="11" class="empty-text">暂无分类数据</td>
          </tr>
          <tr v-else v-for="item in categoryList" :key="getId(item)">
            <td class="image-col">
              <img v-if="item.icon_url" :src="item.icon_url" class="thumb icon-thumb" alt="" />
              <span v-else class="thumb-placeholder">无</span>
            </td>
            <td class="image-col">
              <img v-if="item.cover_url" :src="item.cover_url" class="thumb" alt="" />
              <span v-else class="thumb-placeholder">无</span>
            </td>
            <td>{{ getId(item) }}</td>
            <td class="name-cell">{{ item.name || '—' }}</td>
            <td>{{ item.code || '—' }}</td>
            <td>{{ getCategoryTypeLabel(pickCategoryType(item)) }}</td>
            <td class="desc-cell">{{ item.description || '—' }}</td>
            <td>{{ item.sort_order == null ? 0 : item.sort_order }}</td>
            <td>
              <span class="status-tag" :class="'status-' + item.status">
                {{ getStatusLabel(item.status) }}
              </span>
            </td>
            <td class="time-cell">{{ formatDate(item.updated_at || item.created_at) }}</td>
            <td class="action-col">
              <button type="button" class="action-btn edit-btn" @click="openEdit(item)">
                编辑
              </button>
              <button type="button" class="action-btn delete-btn" @click="handleDelete(item)">
                删除
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="!loading && categoryList.length > 0" class="pagination">
      <button
        type="button"
        class="page-btn"
        :disabled="currentPage <= 1"
        @click="handlePageChange(currentPage - 1)"
      >
        上一页
      </button>
      <span class="page-info">
        第 {{ currentPage }} / {{ totalPages }} 页 · 共 {{ total }} 条
      </span>
      <button
        type="button"
        class="page-btn"
        :disabled="currentPage >= totalPages"
        @click="handlePageChange(currentPage + 1)"
      >
        下一页
      </button>
    </div>
  </div>

  <div v-if="modalVisible" class="modal-mask" @click="closeModal">
    <div class="modal-panel" @click.stop>
      <div class="modal-header">
        <h3>{{ modalTitle }}</h3>
        <button type="button" class="link-btn" :disabled="saving" @click="closeModal">关闭</button>
      </div>

      <div v-if="detailLoading" class="modal-loading">详情加载中...</div>
      <div v-else class="form-body">
        <div class="form-grid">
          <label class="form-field">
            <span>分类名称 <em>*</em></span>
            <input v-model="categoryForm.name" type="text" placeholder="英烈丰碑" />
          </label>

          <label class="form-field">
            <span>分类编码 <em>*</em></span>
            <input v-model="categoryForm.code" type="text" placeholder="yinglie" />
          </label>

          <label class="form-field">
            <span>分类类型 <em>*</em></span>
            <select v-model="categoryForm.category_type">
              <option value="" disabled>请选择类型</option>
              <option
                v-for="item in CATEGORY_TYPE_OPTIONS"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </label>

          <label class="form-field">
            <span>排序</span>
            <input v-model.number="categoryForm.sort_order" type="number" min="0" step="1" />
          </label>

          <label class="form-field">
            <span>状态</span>
            <select v-model="categoryForm.status">
              <option
                v-for="item in CATEGORY_STATUS_OPTIONS"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </label>
        </div>

        <div class="image-upload-grid">
          <div class="image-upload-field">
            <span class="field-label">图标</span>
            <div class="image-preview icon-preview">
              <img v-if="categoryForm.icon_url" :src="categoryForm.icon_url" alt="分类图标" />
              <span v-else>暂无图标</span>
            </div>
            <button
              type="button"
              class="secondary-btn"
              :disabled="uploadingImage"
              @click="triggerImageUpload('icon_url')"
            >
              {{ uploadingImage ? '上传中...' : '上传图标' }}
            </button>
          </div>

          <div class="image-upload-field">
            <span class="field-label">封面</span>
            <div class="image-preview cover-preview">
              <img v-if="categoryForm.cover_url" :src="categoryForm.cover_url" alt="分类封面" />
              <span v-else>暂无封面</span>
            </div>
            <button
              type="button"
              class="secondary-btn"
              :disabled="uploadingImage"
              @click="triggerImageUpload('cover_url')"
            >
              {{ uploadingImage ? '上传中...' : '上传封面' }}
            </button>
          </div>
        </div>

        <label class="form-field full">
          <span>描述</span>
          <textarea
            v-model="categoryForm.description"
            rows="4"
            placeholder="英烈人物与事迹内容"
          ></textarea>
        </label>
      </div>

      <div class="modal-actions">
        <input
          ref="fileInputRef"
          class="hidden-input"
          type="file"
          accept="image/*"
          @change="handleSelectImage"
        />
        <button type="button" class="secondary-btn" :disabled="saving || uploadingImage" @click="closeModal">
          取消
        </button>
        <button type="button" class="primary-btn" :disabled="saving || detailLoading || uploadingImage" @click="handleSave">
          {{ saving ? '保存中...' : '保存' }}
        </button>
      </div>
    </div>
  </div>
</div>
